export const paymentPlans = [{ label: "Default", value: 1 }, { label: "Premium", value: 3 }/* , { label: "Ultra", value: 3 } */]

export const treeTypes = [{ label: "Optionality", value: 2 }, { label: "Second Order", value: 1 }, { label: "Inversion", value: 3 }]